import { useSelector, useDispatch } from 'react-redux'
import { set, unSet } from "../store/userClinic/userClinicSlice";
import { clearOnLocalStorage, getFromLocalStorage, setOnLocalStorage } from '../utils/user-clinic';

export const useUserClinic = () => {
    const userClinic = useSelector(state => state.rootReducer.userClinic.value)
    const dispatch = useDispatch();

    const getUserClinic = () => getFromLocalStorage();

    const setUserClinic = (clinic) => {
        if (!clinic) return;
        dispatch(set(clinic));
        setOnLocalStorage(clinic);
    }
    const unSetUserClinic = () => {
        dispatch(unSet());
        clearOnLocalStorage();
    }

    return {
        userClinic,
        setUserClinic,
        unSetUserClinic,
        getUserClinic
    }
}